module.exports = __webpack_public_path__ + "images/CC_Scorable Images_Correct.png";